// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
/// <summary>
/// AccountOperationRequestMessage
/// </summary>
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class AccountOperationConfirmMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_ACCOUNT_OPERATION_CONFIRM_MESSAGE, fieldSet);
    }
    setOperationType(operationType, serverMaxField) {
        if (serverMaxField >= FieldsFactory.FIELD_OPERATION_TYPE2) {
            this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE2, operationType);
        }
        else {
            this.setFieldValue(FieldsFactory.FIELD_OPERATION_TYPE, operationType);
        }
    }
    setOrderId(orderId) {
        this.setFieldValue(FieldsFactory.FIELD_ORDER_ID, orderId);
    }
    setCrossPrice(crossPrice) {
        this.setFieldValue(FieldsFactory.FIELD_CROSS_PRICE, crossPrice);
    }
    setAmount(amount) {
        this.setFieldValue(FieldsFactory.FIELD_AMOUNT, amount);
    }
    setMode(mode) {
        this.setFieldValue(FieldsFactory.FIELD_MODE, mode);
    }
}
